<template>
  <svg :class="{'fade-out': !loadIn}" :style="svgStyle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280.71 278.88" width="281" height="279" >
    <polyline :class="{ 'svg-elem-1' : loadIn }" points="177.58 19.1 280.71 19.1 280.71 0 .38 0 .38 19.1 158.48 19.1" stroke="#010101" />
    <polyline :class="{ 'svg-elem-2' : loadIn }" points="158.48 .41 158.48 278.88 177.58 278.88 177.58 .41" stroke="#010101" />
    <polyline :class="{ 'svg-elem-3' : loadIn }" points="0 66.3 280.71 66.3 280.71 47.21 0 47.21" stroke="#010101" />
    <polyline :class="{ 'svg-elem-4' : loadIn }" points="102.15 47.41 102.15 278.88 121.24 278.88 121.24 47.41" stroke="#010101" />
  </svg>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    height: { type: String },
  },
  data() {
    return {
      loadIn: true,
    };
  },
  computed: {
    svgStyle() {
      return {
        height: this.height,
      };
    },
  },
  mounted() {
    this.loaderAnimation();
  },
  methods: {
    loaderAnimation() {
      setInterval(() => {
        this.loadIn = false;
        setTimeout(() => {
          this.loadIn = true;
        }, 800);
      }, 4800); // 4.8sec + 1sec
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/_config.scss";

@keyframes animate-svg-stroke-1 {
  0% {
    stroke-dashoffset: 581.7599487304688px;
    stroke-dasharray: 581.7599487304688px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 581.7599487304688px;
  }
}

@keyframes animate-svg-fill-1 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-elem-1 {
  animation: animate-svg-stroke-1 1.5s ease-in-out 0.8s  both,
               animate-svg-fill-1 1.1s ease-in 2.6s  both;
}

@keyframes animate-svg-stroke-2 {
  0% {
    stroke-dashoffset: 578.0400390625px;
    stroke-dasharray: 578.0400390625px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 578.0400390625px;
  }
}

@keyframes animate-svg-fill-2 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-elem-2 {
  animation: animate-svg-stroke-2 1.2s ease-in-out 1.3s  both,
               animate-svg-fill-2 1.1s ease-in 2.6s  both;
}

@keyframes animate-svg-stroke-3 {
  0% {
    stroke-dashoffset: 582.510009765625px;
    stroke-dasharray: 582.510009765625px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 582.510009765625px;
  }
}

@keyframes animate-svg-fill-3 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-elem-3 {
  animation: animate-svg-stroke-3 1.5s ease-in-out 1.45s  both,
               animate-svg-fill-3 1.1s ease-in 2.6s  both;
}

@keyframes animate-svg-stroke-4 {
  0% {
    stroke-dashoffset: 484.0299987792969px;
    stroke-dasharray: 484.0299987792969px;
  }

  100% {
    stroke-dashoffset: 0;
    stroke-dasharray: 484.0299987792969px;
  }
}

@keyframes animate-svg-fill-4 {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(0, 0, 0);
  }
}

.svg-elem-4 {
  animation: animate-svg-stroke-4 1.5s ease-in-out 1.8s  both,
               animate-svg-fill-4 1.1s ease-in 2.6s  both;
}

.fade-out {
  animation: fade-out-animation 0.6s linear forwards;
}

@keyframes fade-out-animation {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
